import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredInspectionPlans,
  selectInspectionPlanFilterVisible,
  selectInspectionPlanLoading,
} from './store/selectors';
import VirtualList from '../components/VirtualList'; // Import VirtualList
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner'; // Import LoadingSpinner
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { showModal } from 'Core/redux/main/slice';
import { Edit, Trash2 } from 'react-feather';
import { Button, ButtonGroup } from 'react-bootstrap';
import { deleteInspectionPlan, fetchInspectionPlanData } from './store/slice';
import { format } from 'date-fns';

const { INSPECTIONPLAN_ADD_EDIT } = MODAL_TYPES;

const InspectionPlanTile = props => {
  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const inventoryTileRef = useRef(null);
  const filteredInspectionPlans = useSelector(selectFilteredInspectionPlans);
  const isLoading = useSelector(selectInspectionPlanLoading);
  const filterVisible = useSelector(selectInspectionPlanFilterVisible);
  const headerVisible = useSelector(isHeaderVisible);

  const updateColumnSettings = useCallback(() => {
    if (inventoryTileRef.current) {
      const width = inventoryTileRef.current.offsetWidth;
      let columns = 6;

      if (width < 576) {
        columns = 1; // Mobile
      } else if (width < 768) {
        columns = 3; // Tablets
      } else if (width < 992) {
        columns = 5; // Large screens
      } else {
        columns = 6; // Extra large screens
      }

      setColumnCount(columns);
      setColumnWidth(width / columns);
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings]);
 
  const itemData = filteredInspectionPlans.map(inspectionPlan => <Tile inspectionPlan={inspectionPlan} />);

  return (
    <div
      className={`shipment-tile-body ${filterVisible ? 'filter-visible' : ''} ${
        !headerVisible ? 'header-collapsed' : ''
      }`}
      ref={inventoryTileRef}
    >
      {isLoading && <LoadingSpinner />}
      {
        <VirtualList
          columnCount={columnCount}
          rowCount={Math.ceil(filteredInspectionPlans.length / columnCount)}
          itemData={itemData}
          columnWidth={columnWidth}
          rowHeight={150} // Adjusted row height
        />
      }
    </div>
  );
};

const Tile = ({ inspectionPlan }) => {

  console.log('InspectionPlan itemData', inspectionPlan);
  const dispatch = useDispatch();

  const handleEdit = e => {
    e.stopPropagation();
      dispatch(fetchInspectionPlanData(inspectionPlan));
  };

  const handleDelete = e => {
    e.stopPropagation();
    //dispatch(deleteInspectionPlan(inventory.processId));
  };

  return (
    <div key={inspectionPlan.inspectionPlanId || Math.random()} className="shipment-tile">
      <div
        className="card p-3 m-2"
        style={{
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="tile-actions">
          <ButtonGroup size="sm">
            <Button variant="light" onClick={handleEdit}>
              <Edit size={16} />
            </Button>
            {/* <Button variant="light" onClick={handleDelete}>
              <Trash2 size={16} />
            </Button> */}
          </ButtonGroup>
        </div>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <div className="ms-2 c-details">
              <h5 className="mb-0">{inspectionPlan.partName} </h5>              
            </div>
          </div>
        </div>
         <br></br> 
        <div className="mt-1"> 
        <span
            className="badge"
            style={{
              backgroundColor: inspectionPlan.backgroundColor || '',
              color: inspectionPlan.textColor || '#FFF',
              fontSize: '14px'
            }}
          >
            {inspectionPlan.inspectionPlanType || 'N/A'}
          </span> 
          {/* <h6 className="heading">{inspectionPlan.inspectionPlanType}</h6> */}
        </div>
        <div className="mt-2">
          <h6 className="heading">  {format(new Date(inspectionPlan.createdDate), 'dd-MMM-yyyy')}</h6>
        </div>
      </div>
    </div>
  );
};

export default InspectionPlanTile;
